import type { IAreaOfPractice } from "../interfaces/models/IAreaOfPractice";
import type { IPersonCreate } from "../interfaces/models/IPersonCreate";

/**
 * Maps the first four entries in `orderedIds` (practice expertise order) to
 * `aopRankName1`–`4` using catalog display names — same contract as Manage Firm → AOP.
 */
export function aopRankNamesPatchFromOrder(
  orderedIds: string[],
  aopById: Map<string, IAreaOfPractice>
): Pick<
  IPersonCreate,
  "aopRankName1" | "aopRankName2" | "aopRankName3" | "aopRankName4"
> {
  const take = orderedIds.slice(0, 4);
  const labelAt = (i: number) => {
    const id = take[i];
    if (!id) {
      return undefined;
    }
    const row = aopById.get(id);
    const n = (row?.displayName ?? "").trim();
    return n || undefined;
  };
  return {
    aopRankName1: labelAt(0),
    aopRankName2: labelAt(1),
    aopRankName3: labelAt(2),
    aopRankName4: labelAt(3),
  };
}
